window.Products.HomeDecor.BedPillowSleeveStandard = function() {};
window.Products.HomeDecor.BedPillowSleeveStandard.inherits(window.Products.HomeDecor.BedPillowSleeve);
window.Products.HomeDecor.BedPillowSleeveStandard.has_3d = true;
window.Products.HomeDecor.BedPillowSleeveStandard.id = '90-standard';
window.Products.HomeDecor.BedPillowSleeveStandard.saveId = 90;
window.Products.HomeDecor.BedPillowSleeveStandard.slug = 'bed-pillow-sleeve-standard';
window.Products.HomeDecor.BedPillowSleeveStandard.dpi = 150;

window.Products.HomeDecor.BedPillowSleeveStandard.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].children[this.designObject].material.map = modelViewer.texture;
	modelViewer.object.children[0].children[this.designObject].material.map.flipY = false;
	modelViewer.object.children[0].children[this.designObject].material.needsUpdate = true;
};